import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { urlServer } from '../global_constants';
import { ServiceResponse } from '../models/service-response';

@Injectable({
  providedIn: 'root'
})
export class VisitService {

  constructor(private httpClient:HttpClient) {
    this.commercialsSubject=new Subject();
    this.sectorsSubject = new Subject();
    this.detailSubject=new Subject();
    this.persoSubject=new Subject();
    this.customersSubject = new Subject();
    this.actionsSubject = new Subject();
    this.customActionsSubject = new Subject();
    this.allActionsSubject = new Subject();
    this.newVisitSubject = new Subject();
    this.topicSubject= new Subject();
    this.retrieveSubject= new Subject();
    this.actionsStatusSubject = new Subject();
    this.reviveWeekSubject = new Subject();
    this.retrieveReviveWeekSubject = new Subject();
    this.reviveCalendarWeekSubject = new Subject();
    this.initAutoReviveSubject = new Subject();
    if(localStorage.getItem("token")!=null && localStorage.getItem("token")!=undefined) 
      this.token = localStorage.getItem("token")
    else this.token = sessionStorage.getItem("token")
   }
   pathApiActions:string="/v1/visit/actions/";
  //COMMERCIAL TO AFFECT variables
  token:any;
  pathApiIndicator:string="/v1/commercials/toAffect";
  commercialsSubject:Subject<any>;
  sectorsSubject:Subject<any>;
  customersSubject:Subject<any>;
  actionsSubject:Subject<any>;customActionsSubject:Subject<any>;
  allActionsSubject:Subject<any>;
  newVisitSubject:Subject<any>;
  userRequest:any;
  urlRequestIndicator: string =urlServer.concat(this.pathApiIndicator);
  pathApiSectors:string="/v1/ref/sectors";
  urlRequestSectorsRef: string =urlServer.concat(this.pathApiSectors);
  urlRequestActionsRef: string =urlServer.concat(this.pathApiActions);
  

  //Detail variables
  pathApiDetail:string="/v1/visit";
  detailSubject:Subject<any>;
  detailRequest:any;
  urlRequestDetail: string =urlServer.concat(this.pathApiDetail);

  //Retrieve variables
  pathApiRetrieve:string="/v1/visit/";
  retrieveSubject:Subject<any>;
  retrieveRequest:any;
  urlRequestRetrieve: string =urlServer.concat(this.pathApiRetrieve);

  //Perso variables
  pathApiPerso:string="/v1/customer/";
  persoSubject:Subject<any>;
  persoRequest:any;
  urlRequestPerso: string =urlServer.concat(this.pathApiPerso);

  //VISIT TOPIC variables
  pathApiTopic:string="/v1/ref/topics";
  topicSubject:Subject<any>;
  topicRequest:any;
  urlRequestTopic: string =urlServer.concat(this.pathApiTopic);

  //VISIT ACTIONS variables
  pathApiActionsStatus1:string="/v1/visit/";
  pathApiActionsStatus2:string="/action/";
  actionsStatusSubject:Subject<any>;
  actionsStatusRequest:any;
  urlRequestActionsStatus: string =urlServer.concat(this.pathApiActionsStatus1);

  //REVIVE WEEK CONFIG variables
  reviveWeekRequest:any;
  reviveWeekSubject:Subject<any>;
  retrieveReviveWeekSubject:Subject<any>;
  reviveCalendarWeekSubject:Subject<any>;
  pathApiReviveStatus:string="/v1/visits/autoRevive";
  pathApiRetrieveReviveStatus:string="/v1/visits/autoReviveWeek";
  pathApiReviveCalendarWeek:string="/v1/visits/autoRevivePlanningWeek";
  pathInitAutoRevives:string="/v1/visits/verifyRevives";
  urlRequestReviveWeek: string =urlServer.concat(this.pathApiReviveStatus);
  urlRequestRetrieveReviveWeek: string =urlServer.concat(this.pathApiRetrieveReviveStatus);
  urlRequestReviveCalendarWeek: string =urlServer.concat(this.pathApiReviveCalendarWeek);
  urlRequestInitAutoRevives: string =urlServer.concat(this.pathInitAutoRevives);

  //MESSAGES VISIT
  //INITIALIZATION AUTO CONFIG REVIVES
  initAutoReviveSubject:Subject<any>;

  //Retrieve visits statistics
  pathApiStatisctics:string="/v1/visits/statistics";
  urlRequestStatisctics: string =urlServer.concat(this.pathApiStatisctics);

    //Retrieve visits statistics
    pathApiCustomerVisits:string="/v1/visits/customer";
    urlRequestCustomerVisits: string =urlServer.concat(this.pathApiCustomerVisits);


  getCommercialsToAffect(){
    this.commercialsSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestIndicator,{headers: header}).subscribe((response: any) => {
      this.commercialsSubject.next(response);
      this.commercialsSubject.complete();
    },error => {
    });
  }

  getSectors(){
    this.sectorsSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestSectorsRef,{headers: header}).subscribe((response: any) => {
      this.sectorsSubject.next(response);
      this.sectorsSubject.complete();
    },error => {
    });
  }

  getCustomersSector(uuid:any){
    this.customersSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestSectorsRef+"/"+uuid+"/customers",{headers: header}).subscribe((response: any) => {
      this.customersSubject.next(response);
      this.customersSubject.complete();
    },error => {
    });
  }

  getPublicActions(){
    this.actionsSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestActionsRef+"public",{headers: header}).subscribe((response: any) => {
      this.actionsSubject.next(response);
      this.actionsSubject.complete();
    },error => {
    });
  }

  getAllCustomizedActions(){
    this.customActionsSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestActionsRef+"customize",{headers: header}).subscribe((response: any) => {
      this.customActionsSubject.next(response);
      this.customActionsSubject.complete();
    },error => {
    });
  }

  getDetail(id:any){
    this.detailSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestDetail+"/"+id,{headers: header}).subscribe((response: any) => {
        this.detailSubject.next(response);
        this.detailSubject.complete();
    },
      error => {
      }
    );
  }

  getCustomerByVisit(id:any, filters: string[]){
    this.detailSubject = new Subject();
    const url = `${this.urlRequestDetail}/${id}?filter=${filters.join(',')}`;
    this.httpClient.get(url).subscribe((response: any) => {
        this.detailSubject.next(response);
        this.detailSubject.complete();
    },
      error => {
      }
    );
  }
  
  getCustumizedactions(id:any){
    this.persoSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestPerso+id+"/actions",{headers: header}).subscribe((response: any) => {
        this.persoSubject.next(response);
        this.persoSubject.complete();
    },
      error => {
      }
    );
  }
  CustumizedListAllactions(){
    this.allActionsSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+sessionStorage.getItem("token") );
    this.httpClient.get(this.urlRequestActionsRef+"customize",{headers: header}).subscribe((response: any) => {
        this.allActionsSubject.next(response);
        this.allActionsSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      });
    }
  newVisitRequest:any;
  newVisit() {
    this.newVisitSubject = new Subject();
    const body = this.newVisitRequest;
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.post(this.urlRequestDetail, body,{headers: header}).subscribe((response: any) => {
        this.newVisitSubject.next(response);
        this.newVisitSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }
  getTopic(){
    this.topicSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestTopic,{headers: header}).subscribe((response: any) => {
        this.topicSubject.next(response);
        this.topicSubject.complete();
    },
      error => {
      }
    );
  }
  getRetrieve(id:any){
    this.retrieveSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
      header = header.set('authorization', "Bearer "+this.token );
      this.httpClient.get(this.urlRequestRetrieve+id,{headers: header}).subscribe((response: any) => {
        this.retrieveSubject.next(response);
        this.retrieveSubject.complete();
   },)
  }

  updateStatusActionw(newStatus:any,uuidAction:any,visit:any) {
    this.actionsStatusSubject = new Subject();
    this.actionsStatusRequest = {
      status:newStatus
    }
    const body = this.actionsStatusRequest;
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.patch(this.urlRequestActionsStatus+visit+this.pathApiActionsStatus2+uuidAction, body,{headers: header}).subscribe((response: any) => {
        this.actionsStatusSubject.next(response);
        this.actionsStatusSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  updateStatusAction(newStatus:string, motif: string, uuidAction:string, visit:string): Observable<any> {
    this.actionsStatusRequest = {
      status:newStatus,
      cause: motif
    };
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+ this.token);
    return this.httpClient.patch(this.urlRequestActionsStatus+visit+this.pathApiActionsStatus2+uuidAction, this.actionsStatusRequest, {headers: header});
  }

  retrieveReviveSlot() {
    this.retrieveReviveWeekSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestRetrieveReviveWeek,{headers: header}).subscribe((response: any) => {
        this.retrieveReviveWeekSubject.next(response);
        this.retrieveReviveWeekSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }
  setConfigReviveWeek() {
    this.reviveWeekSubject = new Subject();
    const body = this.reviveWeekRequest;
    let header: HttpHeaders = new HttpHeaders();
    
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.post(this.urlRequestReviveWeek, body,{headers: header}).subscribe((response: any) => {
        this.reviveWeekSubject.next(response);
        this.reviveWeekSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }
  setConfigReviveCalendarWeek() {
    this.reviveCalendarWeekSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestReviveCalendarWeek,{headers: header}).subscribe((response: any) => {
        this.reviveCalendarWeekSubject.next(response);
        this.reviveCalendarWeekSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }
  autoConfigInitialisation() {
    this.initAutoReviveSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestInitAutoRevives,{headers: header}).subscribe((response: any) => {
        this.initAutoReviveSubject.next(response);
        this.initAutoReviveSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  getVisitsStatistics(): Observable<ServiceResponse>{
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    return  this.httpClient.get<ServiceResponse>(this.urlRequestStatisctics,{headers: header});
  }
  getCustomerVisits(uuid: string){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    return  this.httpClient.get<ServiceResponse>(`${this.urlRequestCustomerVisits}/${uuid}`,{headers: header});
  }
}
